import React, { useEffect, useState } from "react";
import Location from "../../assets/TaskerProfile/location.png";
import Star from "../../assets/TaskerProfile/star.png";
import Button from "../../components/Form/CustomButton";
import Edit from "../../assets/TaskerProfile/edit.png";
import ReviewSection from "../../components/Tasker/TaskerProfileReview";
import SlidingTabs from "../../components/Common/SlidingTabs";
import { useSelector } from "react-redux";
import { useThunk } from "../../hooks/useThunk";
import { getAllOrders, getTaskerProfile } from "../../store";
import ProfileImage from "../../components/Common/ProfileImage";
import Loader from "../../components/Common/Loader";
import ErrorDisplay from "../../error/ErrorDisplay";
import { useNavigate } from "react-router-dom";
import ReviewCardSkeleton from "../../components/skeleton/ReviewCardSkeleton";
import TaskerProfileSkeleton from "../../components/skeleton/TaskerProfileSkeleton";

function TaskerProfile() {
  const navigate = useNavigate();

  const [
    doGetTaskerProfileDetails,
    isGettingTaskerProflieDetails,
    gettingTaskerProfileDetailsError,
  ] = useThunk(getTaskerProfile);

  const [doGetAllOrders, isGetAllOrders, getAllOrdersError] =
    useThunk(getAllOrders);

  const user = useSelector((state) => state.auth.user);
  const taskerId = user ? user._id : null;

  const [taskerProfileDetails, setTaskerProfileDetails] = useState({});

  const [professionalDetails2, setProfessionalDetails2] = useState([]);
  const [activeCategory2, setActiveCategory2] = useState(null);

  const [serviceAreas2, setServiceAreas2] = useState([]);
  const [activeServiceArea2, setActiveServiceArea2] = useState(null);
  const [subcities, setSubcities] = useState([]);

  // Note: fetch Reviews
  const [reviews, setReviews] = useState([]);
  const [offset, setOffset] = useState(0);
  const LIMIT = 3;
  const [hasMore, setHasMore] = useState(true);
  const [totalReviews, setTotalReviews] = useState(true);

  const fetchTaskerDetails = async () => {
    fetchReviews();

    const taskerProfileDeatils = await doGetTaskerProfileDetails();
    setTaskerProfileDetails(taskerProfileDeatils?.response?.data);

    // console.log("Tasker_Profile", taskerProfileDeatils?.response?.data);

    if (taskerProfileDeatils?.success) {
      const fetchedProfessionalDetails =
        taskerProfileDeatils?.response?.data?.professionalDetails?.primary ||
        [];
      const fetchedServiceAreas =
        taskerProfileDeatils?.response?.data?.servingAreas?.primary || [];

      const transformedProfessionalDetails = fetchedProfessionalDetails.map(
        (category) => ({
          ...category,
          skills: category.skills.map((skill) => ({
            name: skill.skillName,
            description: skill.description,
          })),
        })
      );

      const transformedServiceArea = fetchedServiceAreas.map((serviceArea) => ({
        ...serviceArea,
        city: serviceArea.cityName,
        subcity: serviceArea.subcities.map((subcity) => ({
          name: subcity,
        })),
      }));

      setProfessionalDetails2(transformedProfessionalDetails);

      if (fetchedProfessionalDetails.length > 0) {
        setActiveCategory2(transformedProfessionalDetails[0]);
      }

      if (transformedServiceArea.length > 0) {
        setActiveServiceArea2(transformedServiceArea[0]);
        setServiceAreas2(transformedServiceArea);
      }
    }
  };

  useEffect(() => {
    fetchTaskerDetails();
  }, [taskerId]);

  const fetchReviews = async () => {
    const orders = await doGetAllOrders({
      userId: taskerId,
      isReviews: true,
      limit: LIMIT,
      offset: offset,
    });

    const totalDocuments = orders?.response?.data?.pagination?.totalDocuments;
    setTotalReviews(totalDocuments);

    const userReviews = orders?.response?.data?.data
      .map((order) => ({
        review: order?.userReview,
        price: order?.price,
        userFirstName: order?.user.firstName,
        userLastName: order?.user?.lastName,
        profilePicture: order?.user?.profilePicture,
      }))
      .filter((review) => review !== undefined && review !== null);

    setReviews((prevReviews) => [...prevReviews, ...userReviews]);

    if (reviews.length + userReviews.length >= totalDocuments) {
      setHasMore(false);
    }

    setOffset((prevOffset) => prevOffset + 3);
  };

  useEffect(() => {
    if (serviceAreas2.length > 0) {
      const firstServiceArea = serviceAreas2[0];
      setActiveServiceArea2(firstServiceArea);
      setSubcities(firstServiceArea?.subcity);
    } else if (activeServiceArea2 && activeServiceArea2?.subcity?.length > 0) {
      setSubcities(activeServiceArea2?.subcity);
    }
  }, [serviceAreas2, activeServiceArea2]);

  const filterSkills2 = () => {
    const foundCategory = professionalDetails2?.find(
      (item) => item?.categoryName === activeCategory2?.categoryName
    );
    return foundCategory ? foundCategory.skills : [];
  };

  console.log('Tasker Profile', taskerProfileDetails);

  return (
    <>
      <div className="w-full min-w-[320px] px-5 sm:px-[20px] md:px-[40px] lg:px-[100px] mt-12 mb-10">
        <div className="main-container mt-[12px] p-5 sm:p-[24px] md:p-[36px] flex flex-col  rounded-[20px]  border-[1px] border-[#DDE1E6] bg-[#fff] gap-[24px] ">
          {isGettingTaskerProflieDetails || isGetAllOrders ? (
            <div className="">
              <TaskerProfileSkeleton/>
            </div>
            
          ) : gettingTaskerProfileDetailsError ? (
            <ErrorDisplay
              errorMessage={
                gettingTaskerProfileDetailsError?.message || "An error occurred"
              }
              buttonText="Try Again"
              onButtonClick={fetchTaskerDetails}
            />
          ) : (
            <>
              <div className="top-content flex lg:flex-row md:gap-[46px] gap-[30px] flex-col ">
                {/* Profile Image Section */}
                <div className="left-container min-w-[12vw] flex flex-col items-center">
                  <div className="w-36 h-36">
                    <ProfileImage
                      profilePicture={taskerProfileDetails.profilePicture}
                      firstName={taskerProfileDetails.firstName}
                      lastName={taskerProfileDetails.lastName}
                      fontSize="text-[42px]"
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <div className="flex mt-[34px] gap-[9px] justify-center items-center">
                      <img src={Location} alt="location"></img>
                      <p className="font-inter font-normal text-[12px] text-[#4A4A4A]">
                        {`${serviceAreas2[0]?.cityName}, ${serviceAreas2[0]?.subcities[0]}`}
                      </p>
                    </div>
                    <div className="flex justify-center">
                      <div className="inline-block whitespace-nowrap bg-gray-100 px-2 rounded-md shadow-sm text-content font-inter text-[12px] font-normal leading-6 max-w-52">
                        {`Total Orders: ${taskerProfileDetails?.totolCompletedOrders?.length ?? 0}`}
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-start items-center gap-[9px] mt-[8px]">
                    <img src={Star} alt="Star"></img>
                    <p className="font-inter font-normal text-[12px] text-[#4A4A4A]">
                      {`5.0 (${totalReviews} Reviews)`}
                    </p>
                  </div>
                  {/* <div className="mt-[8px] flex justify-center items-center bg-[#FBC948] rounded-[10px] px-[24px] py-[4px] border-[#FBC948] text-dark font-inter font-semibold text-[12px] text-center">
                    {`Level ${taskerProfileDetails.level || 1} Seller`}
                  </div> */}
                </div>
                {/* Profile Details Section */}
                <div className="right-container lg:max-w-[56vw] flex flex-col gap-[24px]">
                  <p className="font-semibold text-[32px] text-[#0F161E] font-nonito_sans ">
                    {` ${taskerProfileDetails.firstName} ${taskerProfileDetails.lastName}`}
                  </p>
                  <div className="flex flex-col gap-[8px]">
                    <p className="font-medium font-inter text-[16px] text-[#222325]">
                      About Me
                    </p>
                    <p className="font-normal font-inter text-[14px] text-[#404145] text-justify">
                      {taskerProfileDetails?.aboutMe?.primary}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <h3 className="font-inter font-medium text-base sm:text-level-5 text-dark">
                      Service Areas
                    </h3>

                    <div className=" flex gap-[12px] flex-wrap overflow-x-auto w-full ">
                      <SlidingTabs
                        items={serviceAreas2}
                        displayKey="city"
                        activeItem={activeServiceArea2}
                        onItemSelect={setActiveServiceArea2}
                        swipeEnabled={true}
                        image={true}
                      />
                    </div>
                    <h3 className="font-inter font-medium text-base sm:text-level-5 text-dark mt-[1.5rem]">
                      Sub City
                    </h3>
                    <div className="  flex flex-row gap-2 ">
                      {subcities.map((city, index) => (
                        <div
                          key={index}
                          className="bg-[#FAFAFA] w-auto rounded-[1.25rem] px-[1.25rem] py-[0.75rem] text-bold font-inter text-[0.875rem]"
                        >
                          {city.name}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <p className="font-medium font-inter text-[16px] text-[#222325]">
                      Categories
                    </p>
                    <div className=" flex gap-[12px] flex-wrap overflow-x-auto w-full">
                      <SlidingTabs
                        items={professionalDetails2}
                        displayKey="categoryName"
                        activeItem={activeCategory2}
                        onItemSelect={setActiveCategory2}
                        swipeEnabled={true}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col gap-[8px]">
                    <p className="font-medium font-inter text-[16px] text-[#222325]">
                      Skills
                    </p>
                    <div className=" flex gap-[12px] flex-wrap overflow-x-auto w-full">
                      <SlidingTabs items={filterSkills2()} displayKey="name" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="bottom-content flex justify-end">
                <Button
                  buttonText="Edit Profile"
                  icon={<img src={Edit} alt="Edit" />}
                  iconPosition="left"
                  className="gap-2 px-[16px]"
                  width="0"
                  bgColor="bg-[#FBC948]"
                  textColor="text-black"
                  textWeight="font-bold"
                  onClick={() => navigate("/service-pro/edit-profile")}
                />
              </div>
            </>
          )}
        </div>

        <div className="main-container mt-[12px] p-5 sm:p-[24px] md:p-[36px] flex flex-col  rounded-[20px]  border-[1px] border-[#DDE1E6] bg-[#fff]">
          {isGetAllOrders || isGettingTaskerProflieDetails ? (
            <div>
              <div className="flex justify-between mb-[36px]">
                <p className="font-inter font-medium text-[16px] text-[#222325] ">
                  Most Recent
                </p>
              </div>
              <div className="flex flex-col gap-[14px]">
                {[0, 1, 2].map((index) => (
                  <ReviewCardSkeleton key={index} />
                ))}
              </div>
            </div>
          ) : reviews?.length > 0 ? (
            <>
              <div className="flex justify-between mb-[36px]">
                <p className="font-inter font-medium text-[16px] text-[#222325] ">
                  {`1-${reviews.length} out of ${totalReviews}`}
                </p>
                <p className="font-inter font-medium text-[16px] text-[#222325] ">
                  Most Recent
                </p>
              </div>
              {reviews.map((reviewData, index) => (
                <ReviewSection
                  key={index}
                  customerFeedback={reviewData?.review?.customerFeedback}
                  rating={reviewData?.review?.rating}
                  createdAt={reviewData?.review?.createdAt}
                  price={reviewData?.price}
                  firstName={reviewData?.userFirstName}
                  lastName={reviewData?.userLastName}
                  profilePicture={reviewData?.profilePicture}
                />
              ))}
              {hasMore && (
                <button
                  className="self-center lg:px-[186px] md:px-[150px] px-[80px] py-[16px] bg-[#FBC948] rounded-[12px] text-center font-inter font-semibold text-[#0F161E] text-[16px]"
                  onClick={fetchReviews}
                >
                  Load More
                </button>
              )}
            </>
          ) : (
            <div className="flex justify-center items-center py-8">
              <p className="font-inter font-medium text-[16px] text-[#222325] ">
                No Reviews Yet
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TaskerProfile;
